import { Loader2 } from "lucide-react";

/**
 * Gold spinner + skeleton rows. Use on admin pages BEFORE data arrives so
 * users see "loading" instead of a misleading "0 of 0 · No records" flash.
 *
 * Props:
 *   rows      — number of skeleton table rows to render (default 6)
 *   label     — main text (default "Loading…")
 *   subLabel  — secondary text (optional)
 *   testid    — data-testid for the wrapper
 */
export default function LoadingSkeleton({ rows = 6, label = "Loading…", subLabel, testid = "loading-skeleton" }) {
  return (
    <div className="w-full" data-testid={testid}>
      <div className="flex items-center gap-3 py-6">
        <Loader2 className="w-5 h-5 text-amber-400 animate-spin"/>
        <div>
          <div className="text-sm font-heading text-amber-300">{label}</div>
          {subLabel && <div className="text-[11px] text-slate-500">{subLabel}</div>}
        </div>
      </div>
      <div className="space-y-2" aria-hidden="true">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i}
               className="h-10 rounded-md bg-gradient-to-r from-slate-800/60 via-slate-700/50 to-slate-800/60 animate-pulse"
               style={{ animationDelay: `${i * 60}ms` }}/>
        ))}
      </div>
    </div>
  );
}
